import { createFileRoute, redirect } from '@tanstack/react-router'
import AddVisitlog from '@/visits/visit-logs/views/user/add-update/addVisitLog';

export const Route = createFileRoute(
  '/_authenticated/visitLog/$id/$visitId/addVisitLog',
)({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: '/login' });
    }


    const { isServicioTecnico, isAsesorComercial } = context.userRoles;

    // verifica si tiene al menos uno de los roles
    if (!isServicioTecnico && !isAsesorComercial) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  component: VisitDetail,
});

function VisitDetail() { 
  const { id, visitId } = Route.useParams();

  return (
    <div className="container mx-auto py-6">
      <AddVisitlog visitId={visitId} userId={id} />
    </div>
  );
}